module.exports = __webpack_public_path__ + "static/media/more-icon-gray.f8cc17bd.svg";